import { render, staticRenderFns } from "./HomeMainBannerV2.vue?vue&type=template&id=e357d1e6&"
import script from "./HomeMainBannerV2.vue?vue&type=script&lang=js&"
export * from "./HomeMainBannerV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports